import $ from 'jquery';

$(function () {
	$('.hamburger-button').on('click', function () {
		let $hamburger = $('.hamburger-button');
		if ($hamburger.hasClass('inactive')) {
			$hamburger.removeClass('inactive').addClass('active');
			$('.mobile-menu-slider').removeClass('closed').addClass('open');
		} else if ($hamburger.hasClass('active')) {
			$hamburger.removeClass('active').addClass('inactive');
			$('.mobile-menu-slider').removeClass('open').addClass('closed');
		}
	});
});
